/* Upgrade native variant links on product cards, including cards inserted by filters. */
if (!customElements.get('ali-card-swatches')) {
  customElements.define('ali-card-swatches', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.card = this.closest('.product-card-wrapper');
      this.choices = Array.from(this.querySelectorAll('[data-ali-swatch]'));
      if (!this.card || !this.choices.length) return;
      this.initialized = true;
      this.directContainer = this.card.querySelector('[data-ali-direct-add]');
      this.productForm = this.directContainer?.querySelector('product-form');
      this.addEventListener('click', (event) => {
        const choice = event.target.closest('[data-ali-swatch]');
        if (!choice || !this.contains(choice)) return;
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
        event.preventDefault();
        // Do not change the visible shade while a different shade is being added.
        if (this.productForm?.querySelector('[type="submit"]')?.classList.contains('loading')) return;
        this.select(choice);
      });
      const initial = this.choices.find((choice) => choice.dataset.variantId === this.dataset.currentVariant) || this.choices[0];
      this.select(initial);

      if (this.directContainer) {
        customElements.whenDefined('product-form').then(() => {
          if (!this.isConnected) return;
          this.directContainer.hidden = false;
          const fallback = this.card.querySelector('[data-ali-fallback]');
          if (fallback) fallback.hidden = true;
        });
      }
    }

    select(choice) {
      const variantId = choice.dataset.variantId;
      const available = choice.dataset.available === 'true';
      this.choices.forEach((item) => {
        if (item === choice) item.setAttribute('aria-current', 'true');
        else item.removeAttribute('aria-current');
      });
      this.querySelector('[data-ali-color-name]').textContent = choice.dataset.colorName;
      this.dataset.currentVariant = variantId;

      // These markers target only the card links, not cart buttons or modal contents.
      this.card.querySelectorAll('[data-ali-product-link], [data-ali-fallback]').forEach((link) => {
        link.setAttribute('href', choice.getAttribute('href'));
      });
      this.card.querySelectorAll('modal-opener [data-product-url]').forEach((button) => {
        button.dataset.productUrl = choice.getAttribute('href');
      });

      const image = this.card.querySelector('.card__media .media > img:first-child');
      if (image && choice.dataset.imageSrc) {
        image.setAttribute('srcset', choice.dataset.imageSrcset);
        image.setAttribute('src', choice.dataset.imageSrc);
        image.setAttribute('alt', choice.dataset.imageAlt);
        image.setAttribute('width', choice.dataset.imageWidth);
        image.setAttribute('height', choice.dataset.imageHeight);
        this.card.classList.add('ali-card-color-selected');
      }

      const template = Array.from(this.querySelectorAll('template[data-ali-variant-template]'))
        .find((item) => item.dataset.aliVariantTemplate === variantId);
      if (template) {
        const price = this.card.querySelector('[data-ali-card-price]');
        const priceContent = template.content.querySelector('[data-ali-price-content]');
        if (price && priceContent) price.replaceChildren(...Array.from(priceContent.childNodes, (node) => node.cloneNode(true)));
        const badgeContent = template.content.querySelector('[data-ali-badge-content]');
        if (badgeContent) this.card.querySelectorAll('[data-ali-card-badge]').forEach((badge) => {
          badge.replaceChildren(...Array.from(badgeContent.childNodes, (node) => node.cloneNode(true)));
          if (badge.firstElementChild) badge.firstElementChild.id = badge.dataset.aliCardBadge;
        });
      }

      if (!this.productForm) return;
      const idInput = this.productForm.querySelector('[name="id"]');
      const button = this.productForm.querySelector('[type="submit"]');
      idInput.value = variantId;
      idInput.disabled = !available;
      button.disabled = !available;
      button.removeAttribute('aria-disabled');
      button.querySelector('span').textContent = available ? this.dataset.addLabel : this.dataset.soldOutLabel;
      button.querySelector('span').classList.remove('hidden');
      button.querySelector('.sold-out-message')?.classList.add('hidden');
      button.setAttribute('aria-label', `${available ? this.dataset.addLabel : this.dataset.soldOutLabel}: ${choice.dataset.colorName}`);
      this.productForm.error = false;
      this.productForm.handleErrorMessage?.();
    }
  });
}
